<script setup lang="ts">
import type {
  EventScout,
  EventScoutRank,
} from '@collector/sportsapi-client-legacy'

defineProps<{
  label: string
  rank: EventScoutRank
  eventScouts: EventScout[]
}>()
</script>

<template>
  {{ label }}
  <span
    class="sentry-mask ml-1 font-bold"
    :class="{
      'text-error-5': !eventScouts.find((scout) => scout.rank === rank)
        ?.full_name,
    }"
  >
    {{
      eventScouts.find((scout) => scout.rank === rank)?.full_name ||
      'Not assigned'
    }}
  </span>
</template>
